import { useCookie } from "#imports";
import { defineStore } from "pinia";
export const useUserStore = defineStore("userStore", {
  state: () => ({
    currentUserId: null,
    currentUser: null,
    users: { paginatorInfo: { count: 0 }, data: [] },
    user: null
  }),
  actions: {
    setUsers(users) {
      this.users = users;
    },
    setUser(user) {
      this.user = user;
    },
    logout() {
      const refreshToken = useCookie("auth-refresh-token");
      const accessToken = useCookie("auth-access-token");
      refreshToken.value = null;
      accessToken.value = null;
      this.currentUser = null;
    }
  }
});
